import { Helmet } from 'react-helmet-async';

const ProfessionalServiceSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://cititekpro.com/#professionalservice",
    "name": "CitiTekPro - Custom Software Development & IT Solutions",
    "image": "https://cititekpro.com/og-image.png",
    "description": "Professional software development and IT consulting services for businesses in Minneapolis and Minnesota. Specializing in custom software, web development, mobile apps, SEO, and business automation.",
    "url": "https://cititekpro.com",
    "email": "contact@cititekpro.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2910 Pillsbury Ave, Suite 31",
      "addressLocality": "Minneapolis",
      "addressRegion": "MN",
      "postalCode": "55408",
      "addressCountry": "US"
    },
    "priceRange": "$$",
    "areaServed": [
      { "@type": "City", "name": "Minneapolis" },
      { "@type": "City", "name": "Saint Paul" },
      { "@type": "City", "name": "Bloomington" },
      { "@type": "City", "name": "Brooklyn Park" },
      { "@type": "City", "name": "Brooklyn Center" },
      { "@type": "City", "name": "Plymouth" },
      { "@type": "City", "name": "Maple Grove" },
      { "@type": "City", "name": "Richfield" },
      { "@type": "City", "name": "Burnsville" },
      { "@type": "City", "name": "Eagan" },
      { "@type": "City", "name": "Roseville" },
      { "@type": "City", "name": "Edina" },
      {
        "@type": "Neighborhood",
        "name": "Karmel Mall",
        "containedInPlace": { "@type": "City", "name": "Minneapolis" }
      },
      {
        "@type": "Neighborhood",
        "name": "Cedar-Riverside",
        "containedInPlace": { "@type": "City", "name": "Minneapolis" }
      },
      { "@type": "AdministrativeArea", "name": "Hennepin County" },
      { "@type": "AdministrativeArea", "name": "Ramsey County" },
      { "@type": "State", "name": "Minnesota" }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Professional IT Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Custom Software Development",
            "description": "Tailored software solutions built with modern technologies like MERN stack, AI integration, and cloud platforms."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Web Development",
            "description": "Responsive, high-performance websites and web applications for Minnesota businesses."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Mobile App Development",
            "description": "Native and cross-platform mobile applications for iOS and Android."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "SEO Services",
            "description": "Local SEO, technical SEO, and digital marketing for Minnesota businesses."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "IT Consulting",
            "description": "Strategic technology consulting and digital transformation services."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Business Automation",
            "description": "Email automation, reputation management automation, and financial process automation."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI Software Development",
            "description": "Artificial intelligence and machine learning integration for business applications."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "SaaS Application Development",
            "description": "Cloud-based software as a service application development."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Custom CRM Development",
            "description": "Custom customer relationship management systems tailored to your business process."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "MERN Stack Development",
            "description": "Full-stack JavaScript development using MongoDB, Express, React, and Node.js."
          }
        }
      ]
    },
    "slogan": "Transform Your Business with Expert Digital Solutions"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default ProfessionalServiceSchema;
